import React from 'react'
import { useTranslation } from 'react-i18next';
import "./AfterSales.css"
import Afterbackground from '../../../../assets/images/Afterbackground.png'
import after1 from '../../../../assets/images/after1.png'
import after2 from '../../../../assets/images/after2.png'
import after3 from '../../../../assets/images/after3.png'
import after4 from '../../../../assets/images/after4.png'
import after5 from '../../../../assets/images/after5.png'
import  wave from '../../../../assets/images/wave.png'
function AfterSales() {
  const {t} = useTranslation();
  return (
    <div className='After-main'>
        <div className='After-bacground' style={{ backgroundImage: `url(${Afterbackground})` }}>
                <div className='wave'>
                   <img  src={wave}/>
               </div>       
        </div>
        <div className='After-imgs'>
      <div className='after-afterimg'> 
                  <img src={after1}/>
                  <img src={after2}/>
                  <img src={after3}/>
                  <img src={after4}/>
                  <img src={after5}/>         
                </div>
                </div>
                <div className='after-text'>
                  
                <p>{t('At Ce Enologica, we offer comprehensive after-sales technical assistance.If you need help, were here to provide support and ensure everything is clear.  Our experts are ready to assist with any issues and will come to your location to provide the necessary help.')}</p>
                </div>
                
       
   

    </div>
  )
}

export default AfterSales;